<template>
  <div class="c-info" :class="{'c-info--primary': alert}">
    <div class="c-info__icon">
      <Icon :name="alert ? 'iconAlert' : 'iconQuestion'" />
    </div>
    <div class="c-info__content" :class="{'alertText': alert}">
      <slot />
    </div>
  </div>
</template>

<script>
import Icon from '../components/Icon'

export default {
  name: 'Info',
  components: {
    Icon,
  },
  props: {
    alert: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
.c-info--primary {
  width: auto;
  a {
    cursor: pointer;
  }
}

.alertText {
  font-weight: bold;
}
</style>
